import { useReducer } from "react";
import Api from "./Api";
const initialState = {
    data: [],
    IsLoading: true,
    error: ""
};
const reducer = (state, action) => {
    switch (action.type) {
        case "FETCH_SUCCESS":
            return {
                IsLoading: false,
                data: action.payload,
                error: ""
            };
        case "FETCH_ERROR":
            return {
                IsLoading: false,
                data: [],
                error: action.payload
            };
        default:
            return state;
    }
};
const useFetch = url => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const FetchAll = () => {
        Api.get(url)
            .then(function (response) {
                dispatch({ type: "FETCH_SUCCESS", payload: response.data });
            })
            .catch(function (error) {
                dispatch({ type: "FETCH_ERROR", payload: error });
            })
            .then(function () {
                // always executed
            })
    }

    return { state, FetchAll };
};

export default useFetch;